<script>
    import TagAddHeader from '@/components/page-tag-edit/tag-add/TagAddHeader.vue';
    import TagAddData from '@/components/page-tag-edit/tag-add/TagAddData.vue';

    export default {
        computed: {
            isShow() {return this.$store.getters.IS_SHOW_TAG_ADD}
        },
        components: {
            TagAddHeader: TagAddHeader,
            TagAddData: TagAddData,
        }
    }
</script>


<template>
    <div
        v-if="isShow === true"
        class="left_additional_container"
    >
        <TagAddHeader />
        <hr class="hr_light_98">
        <TagAddData />
    </div>
</template>